import { render, staticRenderFns } from "./ContactTouchForm.vue?vue&type=template&id=65baaf63&scoped=true&"
import script from "./ContactTouchForm.vue?vue&type=script&lang=js&"
export * from "./ContactTouchForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactTouchForm.vue?vue&type=style&index=0&id=65baaf63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65baaf63",
  null
  
)

export default component.exports